import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContactForm from '../../components/ContactForm';
import CTAButton from '../../components/CTAButton';
import SEO from '../../components/SEO';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const DeepCleaning = () => {
  return (
    <>
      <SEO 
        title="Deep Cleaning Services in Kampala | Intensive Home & Office Cleaning"
        description="Professional deep cleaning services in Kampala. Sanitize & refresh your space with our intensive cleaning. Perfect for spring cleaning or pre-event preparation. Call 0752 058 190"
        keywords="deep cleaning Kampala, intensive cleaning Uganda, spring cleaning services, sanitization Kampala, thorough cleaning, house deep clean Uganda"
        url="https://blossomcleaningservices.com/services/deep-cleaning"
      />
      <Header />

      <Box sx={{ position: 'relative', py: 12, backgroundImage: 'url(https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?w=1920&q=80)', backgroundSize: 'cover', backgroundPosition: 'center', '&::before': { content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(34, 51, 95, 0.75)' } }}>
        <Container sx={{ position: 'relative', zIndex: 1 }}>
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <Typography variant="h1" sx={{ mb: 3, color: 'white', fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
              Deep Cleaning Services
            </Typography>
            <Typography variant="h5" sx={{ maxWidth: 800, color: 'rgba(255,255,255,0.95)', mb: 4 }}>
              Comprehensive cleaning that reaches every corner of your space
            </Typography>
            <CTAButton to="/contact">Book Deep Clean</CTAButton>
          </motion.div>
        </Container>
      </Box>

      <Box sx={{ py: 8 }}>
        <Container>
          <Grid container spacing={6}>
            <Grid item xs={12} md={8}>
              <Typography variant="h3" sx={{ mb: 4, fontWeight: 600 }}>
                Intensive Deep Cleaning
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
                Our deep cleaning service goes far beyond regular cleaning. We tackle the dirt and grime that accumulates in hard-to-reach areas, ensuring your entire space is thoroughly cleaned and sanitised.
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
                Perfect for spring cleaning, move-in/move-out situations, or when your space simply needs a comprehensive refresh. Our team uses specialised equipment and techniques to deliver exceptional results.
              </Typography>

              <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
                Deep Clean Includes
              </Typography>
              <Grid container spacing={2}>
                {[
                  'Behind and under furniture',
                  'Inside cabinets and cupboards',
                  'Baseboards and skirting boards',
                  'Window frames and sills',
                  'Light fixtures and ceiling fans',
                  'Door frames and handles',
                  'Kitchen appliances (inside/out)',
                  'Bathroom deep sanitisation',
                  'Wall spot cleaning',
                  'Detailed dusting of all surfaces',
                ].map((item, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      <CheckCircleIcon sx={{ color: 'primary.main', fontSize: 20 }} />
                      <Typography variant="body2">{item}</Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
        <Container maxWidth="md">
          <ContactForm title="Schedule Deep Cleaning" showServiceSelect={false} />
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default DeepCleaning;
